import type { Route } from "./+types/testimonials";
import Page from "../pages/Testimonials";
import { pageMeta } from "../lib/meta";
import { legacy } from "../lib/legacy";
import { OG_IMAGE } from "../config/heroArt";
export async function loader() { return { items: await legacy.testimonials() }; }
export const meta = () => pageMeta({ title: "Testimonials | Gazar", description: "What engineers and mentees say about working with me. Real feedback, real stories.", path: "/testimonials", image: OG_IMAGE.testimonials });
export default function R({ loaderData }: Route.ComponentProps) { return <Page items={loaderData.items} />; }
